/*
 * gramms LP — Sticky CTA bar.
 *
 * Visible whenever the target section is off screen, hidden while it is in
 * view. IntersectionObserver rather than a scroll listener: the browser does
 * the measuring off the main thread, so there is no layout thrash on scroll.
 *
 * No observer support means the bar simply stays visible, which is the safe
 * side to fail on for a call to action.
 */
(function () {
  function setup(bar) {
    if (!bar || bar.dataset.lp1StickyReady === 'true') return;
    bar.dataset.lp1StickyReady = 'true';

    var target = document.getElementById(bar.dataset.target);

    /*
     * The bar hides while ANY of these is on screen, not just the scroll
     * target: once the closing CTA is in view the bar is only covering the
     * button it duplicates.
     */
    var watched = [];
    if (target) watched.push(target);
    (bar.dataset.alsoHide || '').split(',').forEach(function (id) {
      var el = document.getElementById(id.trim());
      if (el && watched.indexOf(el) === -1) watched.push(el);
    });

    function show(visible) {
      bar.classList.toggle('lp1-sticky--visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      /* inert keeps the button out of the tab order while the bar is off
         screen; removeAttribute rather than inert = false for older engines. */
      if (visible) bar.removeAttribute('inert');
      else bar.setAttribute('inert', '');
    }

    if (!watched.length || !('IntersectionObserver' in window)) {
      show(true);
      return;
    }

    /* One observer over all of them; a Set of the ones currently intersecting
       decides visibility, so two overlapping sections cannot fight. */
    var onScreen = [];

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var at = onScreen.indexOf(entry.target);
          if (entry.isIntersecting && at === -1) onScreen.push(entry.target);
          if (!entry.isIntersecting && at !== -1) onScreen.splice(at, 1);
        });
        show(onScreen.length === 0);
      },
      /* A sliver counts as "on screen": the bar should already be gone by the
         time the section has properly entered the viewport. */
      { threshold: 0.01 }
    );

    watched.forEach(function (el) { observer.observe(el); });

    /* The href alone would work, but going through the script lets the scroll
       respect prefers-reduced-motion and the section's own anchor offset. */
    var cta = bar.querySelector('[data-lp1-sticky-cta]');
    if (cta) {
      cta.addEventListener('click', function (event) {
        if (!target) return;
        event.preventDefault();
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    }
  }

  function setupAll(scope) {
    Array.prototype.forEach.call(
      (scope || document).querySelectorAll('[data-lp1-sticky]'),
      setup
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setupAll(); });
  } else {
    setupAll();
  }

  document.addEventListener('shopify:section:load', function (event) { setupAll(event.target); });
})();
